module.exports = __webpack_public_path__ + "static/img/DO@3x.19de3c1e.png";